export default __webpack_public_path__ + "static/media/tag-left.acb72fd3.svg";